document.addEventListener('DOMContentLoaded', async () => {
  const priceElements = document.querySelectorAll('[data-product-price]');

  if (!priceElements.length) return;

  for (const el of priceElements) {
    const handle = el.dataset.productPrice;

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) continue;

      const product = await response.json();

      if (!product.price) continue;

      const price = product.price / 100;

      el.textContent = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: Shopify.currency.active
      }).format(price);
    } catch (error) {
      console.warn('Could not load product price:', handle);
    }
  }
});